import { render, staticRenderFns } from "./AccountCustomStatementPage.vue?vue&type=template&id=563c7940&scoped=true&"
import script from "./AccountCustomStatementPage.vue?vue&type=script&lang=js&"
export * from "./AccountCustomStatementPage.vue?vue&type=script&lang=js&"
import style0 from "./AccountCustomStatementPage.vue?vue&type=style&index=0&id=563c7940&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563c7940",
  null
  
)

export default component.exports